import React from 'react';

export default function PoolKandidat() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Pool Kandidat</h1>
      <p className="text-gray-500">Halaman Pool Kandidat</p>
    </div>
  );
}
